/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import AddAction from './AddAction/index'
import CancelAction from './CancelAction/index'
import CloseAction from './CloseAction/index'
import EditAction from './EditAction/index'
import ModalFullScreen from 'DesignSystem/ModalFullScreen/index'
import Profiles from './Profiles/index'
import React from 'react'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import TysiaIconInfoFilled from 'DesignSystem/Svgs/TysiaIconInfoFilled/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/ContactInfo/Email/Emails/Content/Email/Edit/Content/EditOrAdd/Content/Content",
  text
  
}) {
let dtColorsBlue100 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.blue.100'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtColorsBlue700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.blue.700'
        })
let dtColorsBlue600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.blue.600'
        })
let dtTypographyFontsizeM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.fontSize.m'
        })
let dtSpaceL = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.l'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
  return (<React.Fragment
>
<ModalFullScreen
  viewPath={`${viewPath}/ModalFullScreen`}
 height="auto"
>
{childProps => (
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 marginTop={0}
 level="h3"
 text="Edit Email"
/>
<CloseAction
  viewPath={`${viewPath}/CloseAction`}
/>
</div>
<div
  data-testid="Content.Vertical:1"
  data-view-path={viewPath}
 style={{'--bc-1-Z1Yf8zk': dtColorsBlue100,'--bblr-2-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bbrr-3-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btlr-4-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btrr-5-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--mt-6-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pt-7-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pl-8-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-9-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pb-10-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical1}`}
>
<div
  data-testid="Content.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<TysiaIconInfoFilled
  viewPath={`${viewPath}/TysiaIconInfoFilled`}
 fill={dtColorsBlue700}
 marginRight={dtSpaceS}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsBlue600}
 fontSize={dtTypographyFontsizeM}
 text={text}
/>
</div>
</div>
<Profiles
  viewPath={`${viewPath}/Profiles`}
/>
<div
  data-testid="Content.Horizontal:2"
  data-view-path={viewPath}
 style={{'--mt-6-Z1Yf8zk': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL,'--bc-1-Z1Yf8zk': dtColorsWhite}}
 className={`views-block ${styles.Horizontal2}`}
>
<CancelAction
  viewPath={`${viewPath}/CancelAction`}
/>
<div
  data-testid="Content.Horizontal:3"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal3}`}
>
<AddAction
  viewPath={`${viewPath}/AddAction`}
/>
<EditAction
  viewPath={`${viewPath}/EditAction`}
/>
</div>
</div>
</div>
)}
</ModalFullScreen>
{children}
</React.Fragment>)
}